import { Button, Heading, Text, Modal } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import React, { FunctionComponent, useState } from 'react'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { useAppDispatch, authLogout, useAppRouter } from '../../state'
import { useCheckoutSizes } from '../../utils/responsive'
import { Route } from '../../config/router'

import styles from './style.module.css'

interface LogoutFormProps {
  onClose?: () => void
}

export const LogoutForm: FunctionComponent<LogoutFormProps> = ({ onClose }) => {
  const { t } = useTranslation()
  const { sectionHeadingSize, headingSize } = useCheckoutSizes()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const dispatch = useAppDispatch()
  const router = useAppRouter()
  const [showModal, setShowModal] = useState(true)
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  const onLogoutHandler = async (): Promise<void> => {
    setIsLoggingOut(true)
    logEvent('Pressed Logout Button Confirm')
    await dispatch(authLogout())
    router.push(Route.ENTER_EMAIL)
  }

  const onCancelHandler = (): void => {
    setShowModal(false)
    logEvent('Pressed Logout Button Decline')
    if (onClose !== undefined) {
      onClose()
    }
  }

  return (
    <Modal show={showModal} onBackdropClick={onCancelHandler}>
      <Modal.Header>
        <div className={styles.header}>
          <Heading size={headingSize}>{t('logout:heading')}</Heading>
          <Text size={sectionHeadingSize}>{t('logout:text')}</Text>
        </div>
      </Modal.Header>
      <Modal.Footer>
        <div className={styles.footer}>
          <Button kind='Primary' padding='Fluid' size='Large' onClick={onLogoutHandler} aria-label='' testNameSpace='logout-form-cta' loading={isLoggingOut}>
            {t('logout:ctaButtonText')}
          </Button>
          <Button kind='Ghost' padding='Fluid' size='Large' onClick={onCancelHandler} aria-label='' testNameSpace='logout-form-cancel'>
            {t('logout:cancelButtonText')}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
